import { searchApiClient } from '@/datasources/search.datasource';
import {
  SearchApiProfessionalResult,
  SearchApiTermResponse,
} from '@/app/(main)/_components/search-modal/_services/search-api/search-api.type';

export interface FindProfessionalsByTermParams {
  term: string;
  citySlug?: string;
  page?: number;
  limit?: number;
}

export interface FindProfessionalsByTermResult {
  professionals: SearchApiProfessionalResult[];
  hasMore: boolean;
}

export async function findProfessionalsByTerm({
  term,
  citySlug,
  page,
  limit,
}: FindProfessionalsByTermParams): Promise<FindProfessionalsByTermResult> {
  const response = await searchApiClient.get<SearchApiTermResponse<SearchApiProfessionalResult>>(
    '/professionals/find-by-term',
    {
      term,
      city: citySlug,
      page,
      limit,
    },
  );

  return {
    professionals: response.data.data ?? [],
    hasMore: response.data.hasMore ?? false,
  };
}
